export function assetDisplayName(name?: string | null, path?: string | null): string {
  const n = name || "";
  const basename = (path || "").split("/").pop() || "";
  if (!basename || n !== basename) return n;
  return n.replace(/-[a-zA-Z0-9]{12}(\.[^.]+)?$/, "$1");
}
